<template>
  <div id="mainCreditEvaluationRef">
    <div class="top_line">
        <span class="mainName">{{dataObj?(dataObj.chapter1?dataObj.chapter1.baseInfo.mainName:'--'):'--'}}</span>
      </div>
    <el-card class="box-card creditEvaluation" >
    <div slot="header" class="clearfix">
      <span>交易主体信用评价信息</span>
    </div>
    <div class="card-item">
      <!-- <div class="card-title">
        <p
          v-for="(item,index) in tabList"
          :key="index"
          @click="tabToggle(index)"
          :class="{active:index === tabListIndex}"
        >{{item}}</p>
      </div> -->
      <div class="card-content">
         <div>信用评价：</div>
        <!--  v-if="tabListIndex == 0" -->
        <creditEvaluation
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!-- v-if="tabListIndex == 1" -->
        <div>诉讼及仲裁情况：</div>
        <litigationArbitration
          
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!--  v-if="tabListIndex == 2" -->
        <div>信息披露：</div>
        <disclosureList
         
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!--  v-if="tabListIndex == 3" -->
        <div>其他投标证明材料：</div>
        <otherBidFilesList
         
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
        <!--  v-if="tabListIndex == 4" -->
        <div>其他银行账户信息：</div>
        <otherBankInfoList
          :entStatus.sync="entStatusCopy"
          :pageStatus.sync="pageStatusCopy"
        />
      </div>
    </div>
  </el-card>
  </div>
 
</template>
<script>
import creditEvaluation from "./creditEvaluationList";
import litigationArbitration from "./litigationArbitrationList";
import disclosureList from "./disclosureList";
import otherBidFilesList from "./otherBidFilesList";
import otherBankInfoList from "./otherBankInfoList";
export default {
  components: {
    creditEvaluation,
    litigationArbitration,
    disclosureList,
    otherBidFilesList,
    otherBankInfoList
  },
  props: {
    entStatus: {
      type: Number,
      default: 99
    },
    pageStatus: {
      type: String,
      default: ""
    },
    dataObj: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    entStatus: {
      immediate: true,
      handler(val) {
        this.entStatusCopy = val;
      },
      deep: true
    },
    pageStatus: {
      immediate: true,
      handler(val) {
        this.pageStatusCopy = val;
      },
      deep: true
    },
    dataObj: {
      immediate: true,
      deep: true,
      handler(val) {
        // this.personBasicInfoList = val.chapter4?val.chapter4.empInfoList:[];
        // this.personCertificateInfoList = val.chapter4?val.chapter4.empCertList:[];
      },
   
    }
  },
  data() {
    return {
      tabListIndex: 0,
      tabList: [
        "信用评价",
        "诉讼及仲裁情况",
        "信息披露",
        "其他投标证明材料",
        "其他银行账户信息"
      ],
      entStatusCopy: "",
      pageStatusCopy: ""
    };
  },

  methods: {
    tabToggle(index) {
      this.tabListIndex = index;
    }
  }
};
</script>
<style lang="scss" scoped>
.creditEvaluation {
  .card-item {
    .card-title {
      cursor: pointer;
      display: flex;
      align-items: center;
      width: 100%;
      height: 55px;
      border-bottom: 1px solid #ccc;
      line-height: 55px;
      p {
        font-size: 16px;
        margin: 0 32px;
      }
      .active {
        color: #1890ff;
        border-bottom: 2px solid #1890ff;
        margin-bottom: 2px;
      }
    }
    .card-content {
      padding: 10px 0px;
    }
  }
}
#mainCreditEvaluationRef{
  border: 1px solid #d8d8d8;
  .top_line {
      width: 80%;
      height: 50px;
      color: #8a8a8a;
      margin: 0 auto;
      border-bottom: 1px solid #d8d8d8;
      position: relative;
      .mainName {
        position: absolute;
        bottom: 10px;
        right: 0;
      }
    }
}
</style>